module.exports = __webpack_public_path__ + "img/hjfw.a891396.png";